import * as React from 'react';
import type { SVGProps } from 'react';
const SvgThenArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={99}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#C2C8D3"
      d="M8.027 12.25a1.5 1.5 0 0 1 1.5-1.5H89.19V7.987a1.333 1.333 0 0 1 2.04-1.13l6.818 4.26c.835.522.835 1.74 0 2.262l-6.818 4.26a1.333 1.333 0 0 1-2.04-1.13v-2.76H9.527a1.5 1.5 0 0 1-1.5-1.5Z"
    />
    <path
      fill="#E0E3E9"
      d="M27.19 12c0-1.858 0-2.787.123-3.564A10 10 0 0 1 35.626.123C36.403 0 37.332 0 39.19 0h26c1.858 0 2.787 0 3.565.123a10 10 0 0 1 8.312 8.313c.123.777.123 1.706.123 3.564s0 2.787-.123 3.564a10 10 0 0 1-8.312 8.313C67.977 24 67.048 24 65.19 24h-26c-1.858 0-2.787 0-3.564-.123a10 10 0 0 1-8.313-8.313c-.123-.777-.123-1.706-.123-3.564"
    />
    <path
      fill="#363D4E"
      d="M36.15 8.962V7.636h6.963v1.326h-2.697v7.401h-1.569V8.962zm8.305 7.401V7.636h1.581v3.695h4.044V7.636h1.586v8.727H50.08v-3.707h-4.044v3.707h-1.58Zm8.93 0V7.636h5.676v1.326h-4.095v2.369h3.801v1.325h-3.8v2.382h4.128v1.325zm14.461-8.727v8.727H66.44l-4.112-5.944h-.073v5.944h-1.58V7.636h1.414l4.108 5.95h.077v-5.95z"
    />
    <path fill="#fff" d="M6.484 6a6 6 0 1 1 0 12 6 6 0 0 1 0-12" />
    <path
      fill="#C2C8D3"
      d="M10.984 12a4.5 4.5 0 1 0-4.5 4.5V18l-.309-.008A6 6 0 0 1 .492 12.31L.484 12a6 6 0 0 1 6-6l.309.008A6 6 0 0 1 12.484 12l-.008.309A6 6 0 0 1 6.484 18v-1.5a4.5 4.5 0 0 0 4.5-4.5"
    />
  </svg>
);
export default SvgThenArrow;
